// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1m8Jx","boxTitle":"Qualiphy_boxTitle__27dsh","box":"Qualiphy_box__201h3","toggleWrap":"Qualiphy_toggleWrap__FRnXu"};